<template>
  <div>
    <el-dialog title="服务者身份证修改" :visible.sync="addVisible" width="1000px" :close-on-click-modal="false" center>
      <!-- <p style="color: red" v-if="TimeFlag">服务超时，请刷新页面</p> -->


      <div class="readCardTip">证件照片识别信息</div>
      <div style="color:red;font-size:14px;margin:8px 0px 20px 28px;overflow:hidden">
        注意：支持5M以内，png，jpg，jpeg格式上传，要求边缘完整，无明显反光，尽可能清晰可辨识。
        <!-- <el-button type="primary" style="float:right" plain @click="confIdentifyBtn">确认识别</el-button> -->
      </div>
      <el-form :inline="true" size="small"   ref="servantIdCardPic" label-width="100px"
        class="servantIdCardPic"  label-position="top">
        <el-row>
          <el-col :span="10">
            <el-form-item label="上传正面（人像面）照片" style="height:180px">
              <el-upload class="upload-demo" action="123" :limit="1" :on-remove="handleRemoveA"
                accept=".png, .jpg, jpeg" :file-list="fileListFront" list-type="picture" :on-change="handleOnChangeA"
                :before-upload="beforeAvatarUploadA" :auto-upload="false">

                <el-button size="small" type="primary" style="float:left">点击上传</el-button>
                <img style="width:200px;display:inline-block;margin-left:14px;" src="@/assets/image/card-front.png"
                  v-show="fileFrontPhoto == '' || fileFrontPhoto == null" />
              </el-upload>

            </el-form-item>

          </el-col>
          <el-col :span="10">
            <el-form-item label="上传反面（国徽面）照片" style="height:180px">
              <el-upload class="upload-demo" action="123" :on-remove="handleRemoveB" accept=".png, .jpg, jpeg"
                :file-list="fileListBack" list-type="picture" :on-change="handleOnChangeB" :auto-upload="false"
                :limit="1">

                <el-button size="small" type="primary" style="float:left">点击上传</el-button>
                <img style="width:200px;display:inline-block;margin-left:14px;" src="@/assets/image/card-back.png"
                  v-show="fileBackPhoto == '' || fileBackPhoto == null" />
              </el-upload>

            </el-form-item>

          </el-col>
          <el-col :span="4" style="padding-top:50px;">
            <el-button type="primary" plain @click="confIdentifyBtn">确认识别</el-button>
          </el-col>
        </el-row>

      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">关闭</el-button> 

      </span>
    </el-dialog>

   
  </div>
</template>
<script>
//servantRecommend
import globalData from "@/components/common/globaldata/global.data.vue";
import workercrmapi from "@/script/api/workercrmapi";
import moment from "moment";
  
import lrz from "lrz";
export default {
  components: {},
  data() {
    return {
      fileListFront: [],
      fileListBack: [],   
  
      fileFrontPhoto: "",
      fileBackPhoto: "",  
             
     
      addVisible: false, 
      addLoading: false, 
       
        
      workerInfo: {}
    };
  },

  methods: {
    addServantData(workerInfo) {
      this.workerInfo=workerInfo;
      this.addVisible=true;

      this.fileListFront= [];
      this.fileListBack= [];   
  
      this.fileFrontPhoto="",
      this.fileBackPhoto="";  
    }, 

    //确认识别身份证照片
    confIdentifyBtn() {
      console.log(this.fileFrontPhoto);
      if (
        this.fileFrontPhoto == null ||
        this.fileBackPhoto == null ||
        this.fileFrontPhoto == "" ||
        this.fileBackPhoto == ""
      ) {
        this.$message.warning("请上传身份证正面照片或反面照片！");
        return false;
      }
      const loading = this.$loading({
        lock: true,
        text: "正在识别身份证照片中，请耐心等候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });

      let temp = new FormData();
      temp.append("workerSupplierId", this.workerInfo.id);
      temp.append("frontPhoto", this.fileFrontPhoto);
      temp.append("backPhoto", this.fileBackPhoto);
      temp.append("operatorId", globalData.userInfo.id);
      temp.append("operatorName", globalData.userInfo.userName);

      workercrmapi
        .$axiosWorkerOcrVerify(temp)
        .then(res => {
          loading.close(); 
          if (res.data.errno == 0) {
            if (res.data.data.code == "C0" && res.data.data.overCode == 0) {
              this.$message.success(res.data.data.data.respDesc);
              setTimeout(() => {
                this.$message.success('请关闭后刷新页面');
              }, 2000);
            } else {
              this.$message.warning(res.data.data.overMsg);
            }
          } else {
            this.$message.warning(res.data.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
        });
    },
 
    //上传身份证正面
    handleOnChangeA(file, fileListA) {
      // console.log(file);
      this.fileListFront = fileListA;
      console.log("文件大小：", file.raw.size / 1024 / 1024 + "M");

      if (file.raw) {
        this.fileFrontPhoto =file.raw;
        // lrz(file.raw, { quality: 0.9 }).then(rst => {
        //   this.fileFrontPhoto = rst.origin;
        //   console.info(this.fileFrontPhoto);
        // });
      }
    },
    //上传身份证反面
    handleOnChangeB(file, fileListA) {
      this.fileListBack = fileListA;
      console.log(file.raw);
      if (file.raw) {
        this.fileBackPhoto =file.raw;
        // lrz(file.raw, { quality: 0.9 }).then(rst => {
        //   this.fileBackPhoto = rst.origin;
        //   console.log(this.fileBackPhoto);
        // });
      }
    },
    beforeAvatarUploadA(file) {
      console.log("jianlai", file);
      const isJPG = file.type === "image/jpeg" || "image/jpg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG/JEPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isJPG && isLt2M;
    },
    handleRemoveA(file, fileListA) {
      console.log(file, fileListA);
      console.log("关闭");
      this.fileFrontPhoto = null;
      this.fileListFront = [];
      
    },
    handleRemoveB(file, fileListB) {
      console.log(file, fileListB);
      this.fileBackPhoto = null;
      this.fileListBack = []; 
    },
  }
};
</script>
<style scoped>
.servantHandleInfo .el-form-item--mini.el-form-item,
.servantHandleInfo .el-form-item--small.el-form-item {
  margin-bottom: 15px !important;
}

.share-servant-wrapper {
  text-align: right;
  font-size: 16px;
  padding: 0 20px 0 0;
}

/* .el-input--suffix{
display: flex;
}
.el-input-group__append{
  line-height: 32px !important;
} */
.el-form--inline .el-form-item {
  margin-right: 0px;
}

.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}
</style>
